async function loadDpdScript() {
  if (document.getElementById('dpdMapsScript')) return Promise.resolve();

  return new Promise((res, rej) => {
    const script = document.createElement('script');
    script.id = 'dpdMapsScript';
    script.src = 'https://pus-maps.dpd.sk/lib/library.js';
    script.onload = () => res();
    script.onerror = e => rej(e);
    document.body.appendChild(script);
  });
}

/**
 * @typedef DpdPickupPoint
 * @property {string} pusId
 * @property {string} name
 * @property {string} street
 * @property {string} town
 * @property {string} postCode
 * @property {string} countryCode
 */

/**
 * @param {{weight:number,postCode:string,countryCode:string}} data
 * @param {string} apiKey
 * @returns {Promise<DpdPickupPoint>}
 */
export async function openDpdWidget(data, apiKey) {
  await loadDpdScript();

  /** @type {Promise<DpdPickupPoint>} */
  const promise = new Promise((res, rej) => {
    const widget = new DpdPudo.Widget({
      apiKey,
      minWeightInKg: Math.ceil(data.weight),
      zip: data.postCode,
      country: data.countryCode,
    });

    widget
      .open()
      .then(pudo => {
        res({
          pusId: pudo.id,
          name: pudo.name,
          street: pudo.street,
          town: pudo.city,
          postCode: pudo.zip,
          countryCode: pudo.countryCode,
        });
      })
      .catch(code => {
        switch (code) {
          case 'closed_by_user':
            break;
          // handle other codes.
          default:
            break;
        }
        rej(code);
      });
  });

  return promise;
}
